<template>
    <v-dialog width="auto">
        <template v-slot:activator="{ props }">
            <div class="mb-2">
                <v-btn  v-bind="props" size="" id="btn-arrow-settings" variant="flat" color="grey-darken-3" class="pa-3 mb-2">
                    <v-icon size="x-large" :color="color" >mdi-navigation</v-icon>
                </v-btn>
                <v-label class="ml-4" for="btn-arrow-settings">
                    Colore
                </v-label>
            </div>
        </template>
        <template v-slot:default="{ isActive }">
            <v-card theme="dark">
                <v-card-item>
                    <v-card-title>Colore</v-card-title>
                </v-card-item>
                <!-- <v-card-text class="d-flex justify-center">
                    <v-color-picker v-model="localColor" hide-inputs></v-color-picker>
                </v-card-text> -->

                <v-card-text class="d-flex justify-space-evenly">

                    <v-color-picker v-model="color" mode="rgba" hide-inputs></v-color-picker>

                    <!-- <v-btn  
                    v-for="c in colorProposed" 
                    :key="c" 
                    variant="flat" 
                    size="x-small" :color="c" @click="color = c" icon
                    :border="color == c"
                    :class="{ selected: color == c, }"
                    > 
                </v-btn>
                -->
                </v-card-text>

                <v-card-actions class="flex-column">
                    <!-- <v-btn  variant="flat" size="large" color="success" @click="applyColor(); isActive.value = false">
                        <v-icon class="mr-2">mdi-content-save</v-icon>
                        Applica</v-btn><br> -->
                    <v-btn  variant="outlined" size="large" color="white" @click="isActive.value = false">
                        <v-icon>mdi-chevron-down</v-icon>
                        Indietro</v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>

  
<script setup>


 
const color = defineModel("color")



// const colorProposed = [
//     "#ffffff",
//     "#000000",
//     "#ff0000",
//     "#00ff00",
//     "#ffff00",
//     "#00ffff",
//     "#ff00ff",
// ]

const colorProposed = [
    // "#ffffff",
    // "#000000",
    // "#ff0000",
    // "#00ff00",
    // "#ffff00",
    // "#00ffff",
    // "#ff00ff",

    "#e0e0e0",
    "#2a2a2a",
    "#b03a3a",
    "#4a7c4a",
    "#d2c99a",
    "#a4d3d3",
    "#d29fd2",
]


</script>

<style scoped>
.v-btn {
    pointer-events: auto;
    margin: .3em;
}

.selected {
    outline: 7px solid grey;

}


.no-uppercase {
     text-transform: unset !important;
}
</style>

